var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import StoreLazyLoadPlugin from "./StoreLazyLoadPlugin.js";
class AjaxStoreLazyLoad extends StoreLazyLoadPlugin {
  // There's no merging of pluginConfigs
  static get pluginConfig() {
    const config = {};
    for (const prop in super.pluginConfig) {
      config[prop] = [...super.pluginConfig[prop]];
    }
    config.assign.push(
      "updateResponseTotalProperty",
      "updateResponseDataProperty"
    );
    return config;
  }
  // AjaxStore's totalProperty will apply for lazyLoading
  updateResponseTotalProperty(name) {
    this.totalCountProperty = name;
  }
  // AjaxStore's dataProperty will apply for lazyLoading
  updateResponseDataProperty(name) {
    this.dataProperty = name;
  }
  // Scoped to run on the client
  async requestData(params) {
    const {
      totalCountProperty,
      dataProperty
    } = this.lazyLoad, resp = await this.internalLoad(params, "", void 0, false);
    return {
      [totalCountProperty]: resp.json[totalCountProperty],
      [dataProperty]: resp.data
    };
  }
  // Overridden to support params param
  async load(params) {
    const { client } = this, originalStoreParams = client.params;
    if (params) {
      client.params = {
        ...params,
        ...originalStoreParams
      };
    }
    await super.load();
    if (params) {
      client.params = originalStoreParams;
    }
  }
}
__publicField(AjaxStoreLazyLoad, "$name", "AjaxStoreLazyLoadPlugin");
;
AjaxStoreLazyLoad._$name = "AjaxStoreLazyLoad";
export {
  AjaxStoreLazyLoad as default
};
